<template>

  <div class="domain-availability-checker">
      <brave-form>
          <md-field>

            <md-input class="domain-search" value="" placeholder="Type a domain name..."  aria-label="input domain name"></md-input>
          </md-field>
          <md-button
              class="md-accent md-raised"
              type="submit"
              @click="onSubmit">
              Search
            </md-button>
      </brave-form>
  </div>
</template>


<script>


 export default {
   name: 'DomainAvailabilityChecker',
   data: () => ({

   }),
   components: {

   },

   methods: {
     onSubmit: function () {
       window.location.href = '/domains/search/results/' + $('.domain-search').val();

     }
   },
   props: []
 }
</script>




// WEBPACK FOOTER //
// lib/brave-domain/components/domain-availability-checker.vue